import {
  GET_LOST_ORDERS_SUCCESS,
  GET_LOST_ORDERS_FAIL,
  ADD_LOST_ORDER_SUCCESS,
  ADD_LOST_ORDER_FAIL,
  UPDATE_LOST_ORDER_SUCCESS,
  UPDATE_LOST_ORDER_FAIL,
  DELETE_LOST_ORDER_SUCCESS,
  DELETE_LOST_ORDER_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

const INIT_STATE = {
  lostOrders: [],
  date: [],
  managers: [],
  loading: false,
}

const lostOrders = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LOST_ORDERS_SUCCESS:
      return {
        ...state,
        date: action.payload[0],
        lostOrders: action.payload[1],
        managers: action.payload[2],
      };
    case GET_LOST_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_LOST_ORDER_SUCCESS:
      return {
        ...state,
        lostOrders: [...state.lostOrders, action.payload],
        success: { data: "success" },
      };
    case ADD_LOST_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_LOST_ORDER_SUCCESS:
      return {
        ...state,
        lostOrders: state.lostOrders.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      };
    case UPDATE_LOST_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_LOST_ORDER_SUCCESS:
      return {
        ...state,
        lostOrders: state.lostOrders.filter(
          service => service._id.toString() !== action.payload._id.toString()
        ),
      };
    case DELETE_LOST_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default lostOrders
